import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import PaymentMethodButton from './PaymentMethodButton'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { setPriceInterval } from 'store/billing'
import getPriceDetailsForCurrency from 'utils/getPriceDetailsForCurrency'
import getFormattedPrice from 'utils/getFormattedPrice'
import { CommonPriceInterval, PricePoint } from 'store/api/billing/payments.interface'

const Duration = ({
  yearlyPrice: yearlyPricePoint,
  monthlyPrice: monthlyPricePoint,
}: {
  yearlyPrice?: PricePoint
  monthlyPrice?: PricePoint
}): ReactElement => {
  const dispatch = useAppDispatch()
  const priceInterval = useAppSelector(s => s.products.priceInterval)
  const selectedCurrency = useAppSelector(s => s.products.selectedCurrency)

  const yearlyPrice =
    yearlyPricePoint && getPriceDetailsForCurrency(yearlyPricePoint, selectedCurrency?.code)
  const monthlyPrice =
    monthlyPricePoint && getPriceDetailsForCurrency(monthlyPricePoint, selectedCurrency?.code)
  return (
    <Flex
      sx={{
        width: '100%',
        flexDirection: 'column',
        alignItems: ['center', 'flex-start'],
        gap: '1.6rem',
      }}
    >
      <Text variant="size21Weight600Line138" sx={{ color: 'aliceBlue' }} tabIndex={0}>
        Choose Duration
      </Text>
      <Flex
        sx={{
          width: '100%',
          flexDirection: 'column',
          gap: '1.6rem',
        }}
      >
        {yearlyPrice && (
          <PaymentMethodButton
            data-testid="yearly-option"
            ariaLabel="yearly option"
            onClick={(): void => {
              dispatch(setPriceInterval(CommonPriceInterval.YEARLY))
            }}
            isSelected={priceInterval === CommonPriceInterval.YEARLY}
          >
            {`Yearly - ${getFormattedPrice(selectedCurrency, yearlyPrice?.price)}`}
          </PaymentMethodButton>
        )}
        {monthlyPrice && (
          <PaymentMethodButton
            data-testid="monthly-option"
            ariaLabel="monthly option"
            sxButton={{
              mb: 0,
            }}
            onClick={(): void => {
              dispatch(setPriceInterval(CommonPriceInterval.MONTHLY))
            }}
            isSelected={priceInterval === CommonPriceInterval.MONTHLY}
          >
            {`Monthly - ${getFormattedPrice(selectedCurrency, monthlyPrice?.price)}`}
          </PaymentMethodButton>
        )}
      </Flex>
    </Flex>
  )
}

export default Duration
